import { styled } from '@mui/system';
import { IconButton } from '@mui/material';

const GenderButton = styled(IconButton)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.05)',
  backdropFilter: 'blur(6px)',
  borderRadius: '12px',
  border: '2px solid rgba(255, 255, 255, 0.1)',
  color: '#f0f0f0',
  marginBottom: '10px',
  marginLeft: '10px',
  marginRight: '10px',
  width: '48px',
  height: '48px',
  transition: 'all 0.3s ease',
  boxShadow: '0 0 5px rgba(255, 255, 255, 0.05)',

  '&:hover': {
    background: 'rgba(255, 255, 255, 0.1)',
    boxShadow: '0 0 8px rgba(255, 255, 255, 0.1)',
  },

  '&.male': {
    background: 'linear-gradient(160deg,rgba(21, 152, 223, 0.79) 0%, #0a5a90 100%)',
    boxShadow: '0 0 8px rgba(31, 168, 240, 0.6)',
    color: '#ECEFF1',
    border: '2px solid rgba(31, 168, 240, 0.3)',
  },

  '&.female': {
    background: 'linear-gradient(160deg,rgba(237, 45, 131, 0.8) 0%, #7a1047 100%)',
    boxShadow: '0 0 8px rgba(237, 45, 130, 0.6)',
    color: '#ECEFF1',
    border: '2px solid rgba(237, 45, 130, 0.3)',
  },

  '&.selected': {
    border: '2px solid #ffbfe5',
    boxShadow: '0 0 10px #ffbfe588',
  },

  // 🔽 Responsive scaling
  '@media (max-width: 360px)': {
    width: '42px',
    height: '42px',
  },

  '@media (max-width: 320px)': {
    width: '38px',
    height: '38px',
  },
}));

export default GenderButton;
